<section class="public-page contact-page">
  <div class="public-page-shell contact-shell">
    <p class="public-page-kicker">{{ 'contact.kicker' | translate }}</p>
    <h1 class="public-page-title">{{ 'contact.title' | translate }}</h1>
    <p class="public-page-intro">{{ 'contact.intro' | translate }}</p>

    <div class="public-page-grid public-page-grid--two">
      <article class="public-page-card contact-card">
        <h2 class="public-page-card-title">{{ 'contact.cards.support.title' | translate }}</h2>
        <p class="public-page-card-text">{{ 'contact.cards.support.description' | translate }}</p>
        <a class="contact-link" href="mailto:support@busyguys.com">support&#64;busyguys.com</a>
      </article>

      <article class="public-page-card contact-card">
        <h2 class="public-page-card-title">{{ 'contact.cards.business.title' | translate }}</h2>
        <p class="public-page-card-text">{{ 'contact.cards.business.description' | translate }}</p>
        <a class="contact-link" href="mailto:hello@busyguys.com">hello&#64;busyguys.com</a>
      </article>
    </div>

    <section class="public-page-panel contact-panel">
      <div>
        <h2 class="public-page-card-title">{{ 'contact.help.title' | translate }}</h2>
        <p class="public-page-body">{{ 'contact.help.description' | translate }}</p>

        <div class="contact-reasons">
          <article class="contact-reason" *ngFor="let reasonId of reasonIds">
            <h3>{{ ('contact.help.reasons.' + reasonId + '.title') | translate }}</h3>
            <p>{{ ('contact.help.reasons.' + reasonId + '.description') | translate }}</p>
          </article>
        </div>
      </div>

      <div class="contact-actions">
        <a class="public-page-button public-page-button--primary" [routerLink]="['/sign-up-business']">
          {{ 'contact.cta.primary' | translate }}
        </a>
        <a class="public-page-button public-page-button--secondary" [routerLink]="['/features']">
          {{ 'contact.cta.secondary' | translate }}
        </a>
      </div>
    </section>
  </div>
</section>

